import { FREE_PASS_GUEST_LADDER } from '@/consts/urls';

/**
 * *Fallback* per-day credit amounts for a logged-out visitor, in day order.
 *
 * The real ladder is read from `GET /user-promos/…/items`, which answers
 * anonymously with the campaign catalogue (see `useGuestLadderQuery`). This
 * exists only for environments where that endpoint is still token-gated —
 * production as of 2026-09-22 — and should be dropped once it is opened up
 * there, since a hand-maintained copy of campaign data can always drift.
 *
 * Fails closed: unset or malformed yields no amounts and a shape-only track. A
 * guest promised credits the campaign won't grant is worse than no numbers.
 */
const parseGuestLadder = (raw: string): number[] => {
  if (!raw.trim()) return [];

  const amounts = raw.split(',').map((part) => Number(part.trim()));

  return amounts.every((amount) => Number.isInteger(amount) && amount > 0)
    ? amounts
    : [];
};

const GUEST_STREAK_LADDER: number[] = parseGuestLadder(FREE_PASS_GUEST_LADDER);

export default GUEST_STREAK_LADDER;
